import React, { FC } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import styles from './info-box.module.scss';
import InfoIcon from 'src/assets/icons/info.svg';
import WarningIcon from 'src/assets/icons/warningRed.svg';

interface InfoBoxProps {
  title?: string;
  showRedIcon?: boolean;
  containerStyle?: SxProps<Theme>;
  icon?: string;
}

export const InfoBox: FC<InfoBoxProps> = ({
  title,
  icon,
  showRedIcon,
  containerStyle,
}) => {
  return (
    <Box className={styles.container} sx={containerStyle}>
      {icon ? (
        <img src={icon} alt="icon" />
      ) : showRedIcon ? (
        <img src={WarningIcon} alt="warning" />
      ) : (
        <img src={InfoIcon} alt="info" />
      )}
      <Box className={styles.title}>{title}</Box>
    </Box>
  );
};
